import { useState } from 'react';
import { Link } from 'react-router-dom';
import { readDeck } from '../../lib/reviewDeck';

export default function ReviewDeckPage() {
  const cards = readDeck();
  const [index, setIndex] = useState(0);
  const card = cards[index];

  return (
    <div className="font-myanmar mx-auto w-full max-w-lg px-4 pb-24 pt-6" data-testid="review-deck">
      <h1 className="text-2xl font-semibold text-gray-900">ပြန်ကြည့်ရန်</h1>
      <p className="lesson-subtext text-sm text-gray-600">Review deck</p>
      <p className="mt-2 text-sm text-gray-700">Saved cards stay on this device.</p>
      {cards.length === 0 || !card ? (
        <p className="mt-6 text-sm text-gray-700" data-testid="review-empty">Save a card during a lesson. It will show up here.</p>
      ) : (
        <article className="mt-6 rounded-3xl border border-gray-200 bg-white px-5 py-5" data-testid="review-card">
          <p className="text-sm font-semibold text-teal-800">{card.summary ? 'Key takeaway' : card.title}</p>
          <div className="mt-3 space-y-3">
            {card.lines.length === 0 ? <p className="text-sm text-gray-700">Open the lesson to read this card again.</p> : null}
            {card.lines.map((line) => (
              <p key={line.main}>
                <span className="block text-lg font-semibold text-gray-900">{line.main}</span>
                {line.sub ? <span className="lesson-subtext mt-1 block text-sm text-gray-600">{line.sub}</span> : null}
              </p>
            ))}
          </div>
          <div className="mt-5 flex items-center justify-between gap-3">
            <button type="button" className="min-h-[44px] rounded-xl border border-gray-300 px-4 text-sm font-semibold" disabled={index === 0} onClick={() => setIndex((current) => Math.max(0, current - 1))}>Back</button>
            <span className="text-sm text-gray-600">{index + 1}/{cards.length}</span>
            <button type="button" className="min-h-[44px] rounded-xl border border-gray-300 px-4 text-sm font-semibold" disabled={index >= cards.length - 1} onClick={() => setIndex((current) => Math.min(cards.length - 1, current + 1))}>Next</button>
          </div>
          <Link to={`/courses/${card.pathSlug}/topics/${card.lessonSlug}/learn`} className="mt-4 inline-flex min-h-[44px] items-center text-sm font-semibold text-teal-800">
            Open lesson
          </Link>
        </article>
      )}
    </div>
  );
}
